
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/manage-token",
      function () {
        return require("private-next-pages/manage-token.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/manage-token"])
      });
    }
  